enum ConciergeActionEnum {
  SET_CONCIERGE_TREE = 'SET_CONCIERGE_TREE',
}

export default ConciergeActionEnum;
